function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { jsx } from "panel";
import { LottieEl } from "../lottie";
import { SvgIconEl } from "../svg-icon";
import { SpinnerColor, SpinnerSize, SpinnerTheme } from "./types";
import limitedSegLottie from "./limited-seg.lottie";
export function template() {
  const showCustomSpinner = this.attr("theme") !== SpinnerTheme.Default;
  let spinnerClass = {
    "mp-spinner": true,
    "mp-spinner-blue": this.attr("color") === SpinnerColor.Blue,
    "mp-spinner-white": this.attr("color") === SpinnerColor.White,
    "mp-spinner-inherit-color": this.attr("color") === SpinnerColor.Inherit
  };
  if (showCustomSpinner) {
    spinnerClass = {
      "custom-spinner": true,
      [this.attr("theme")]: true
    };
  }
  return /* @__PURE__ */ jsx("div", { class: _objectSpread(_objectSpread({}, spinnerClass), {}, {
    "large-spinner": this.attr("size") === SpinnerSize.Large,
    "medium-spinner": this.attr("size") === SpinnerSize.Medium
  }), "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, !showCustomSpinner ? /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "spinner"
  } }) : null, this.attr("theme") === SpinnerTheme.Fancy && /* @__PURE__ */ jsx(LottieEl, { attrs: {
    config: {
      path: limitedSegLottie
    }
  } }));
}
